import React, { useEffect } from "react";
import { Tune, Search } from "@material-ui/icons";
import * as message from "../../config/CommonMessages";
import * as code from "../../config/Constants";
import { toastMessage } from "../Common/Common";
import HeaderLogin from "../HeaderLogin/HeaderLogin";
import { getAllShopsAction } from "./../../actions/ShopActions";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import noRecord from "./../../assets/img/no-record.png";
import { connect } from "react-redux";
import PhoneNumber from "../Common/phoneNumber";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import placeholderImage from "./../../assets/img/property-placeholder.jpg";
import { DebounceInput } from "react-debounce-input";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import UrlConstants from "../../config/UrlConstants";

function ShopsListing({ getAllShopsAction }) {
  const getPage = () => {
    const width = window.innerWidth;
    console.log("window.innerWidth", window.innerWidth);
    let defaultLimit = 10;
    let defaultPageSizes = [10, 20, 50, 100];

    if (width <= 390) {
      defaultLimit = 2;
      defaultPageSizes = [2, 4, 10, 50, 100];
    } else if (width >= 391 && width < 431) {
      defaultLimit = 4;
      defaultPageSizes = [4, 8, 50, 100];
    } else if (width >= 431 && width < 1024) {
      defaultLimit = 6;
      defaultPageSizes = [6, 12, 50, 100];
    } else if (width >= 1024 && width < 1640) {
      defaultLimit = 8;
      defaultPageSizes = [8, 16, 50, 100];
    } else {
      defaultLimit = 10;
      defaultPageSizes = [10, 20, 50, 100];
    }
    const data = {
      defaultLimit,
      defaultPageSizes,
    };
    return data;
  };

  const handlePageSizeChange = (event) => {
    setPageSize(event.target.value);
    setRerender(!rerender);
  };
  const { defaultLimit, defaultPageSizes } = getPage();
  const history = useHistory();
  const [showLoader, setShowLoader] = React.useState(false);
  const [numberOfPages, setnumberOfPages] = React.useState();
  const [pageNumber, setPageNumber] = React.useState(0);
  const [rerender, setRerender] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(defaultLimit);
  const [pageSizes, setPageSizes] = React.useState(defaultPageSizes);
  const [zipCode, setZipCode] = React.useState("");
  const [searchParam, setSearchParam] = React.useState("");
  const [shops, setShops] = React.useState([]);
  const [showHideSearch, setShowHideSearch] = React.useState(false);

  // useEffect(() => {
  //   updateSize();
  // }, []);

  useEffect(() => {
    setShowLoader(true);
    // getAllShops();
    setTimeout(() => {
      getAllShops();
    }, 2000);
  }, [pageNumber, rerender]);

  function getAllShops() {
    let data = {
      limit: pageSize,
      offset: pageNumber,
      zipcode: zipCode,
      searchParam: searchParam,
      organization: process.env.REACT_APP_APPLICATION_NAME,
    };

    getAllShopsAction(data)
      .then((response) => {
        if (response.status === 200) {
          setShops(response.data.data);
          setnumberOfPages(response.data.total);
          setShowLoader(false);
        } else {
          setShowLoader(false);
          toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
        }
      })
      .catch((err) => {
        setShowLoader(false);
        toastMessage(code.ERROR, message.SOMETHING_WENT_WRONG);
      });
  }

  const handlePageClick = (event) => {
    setPageNumber(event.selected);
  };

  return (
    <div>
      {/* {showLoader ? (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      ) : ( */}
      <div className="reg-page">
        <HeaderLogin />
        <div className="loginBg align-items-end flex-column">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center trans-listing-head shop-listing-head">
            <Col>
              <h4 className="title-med mt-0 pt-1">Studios</h4>
            </Col>

            <Col className="col-auto" align="right">
              <Form inline className="justify-content-end">
                <Row className="trans-listing-head-row">
                  <Col className="col-auto pl-0 d-flex trans-listing-head-button">
                    <div className="multi-permit">
                      <div className="icon-wrapper">
                        <DebounceInput
                          id="search"
                          minLength={0}
                          debounceTimeout={1500}
                          onChange={(e) => {
                            setSearchParam(e.target.value);
                            setPageNumber(0);
                            setRerender(!rerender);
                          }}
                          placeholder="Search by studio name"
                          value={searchParam}
                          autoComplete="off"
                          className="form-control form-control-sm form-control-head"
                        />
                        <span
                          className="form-control-icn"
                          style={{ lineHeight: "25px" }}
                        >
                          <Search />
                        </span>
                      </div>
                    </div>

                    <div className="multi-permit">
                      <FormControl sx={{ m: 0, minWidth: 120 }} size="small">
                        <InputLabel id="demo-select-small">Limit</InputLabel>
                        <Select
                          labelId="demo-select-small"
                          id="demo-select-small"
                          value={pageSize}
                          label="Page"
                          onChange={handlePageSizeChange}
                        >
                          {pageSizes &&
                            pageSizes.map((size) => (
                              <MenuItem key={size} value={size}>
                                {size}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>

                    <div className="multi-permit">
                      <Button
                        variant="primary"
                        className="btn-blue btn-head"
                        onClick={() => {
                          setShowHideSearch(!showHideSearch);
                        }}
                        style={{
                          backgroundColor: "black",
                          border: "none",
                          marginTop: "1px",
                        }}
                      >
                        <Tune style={{ color: "white" }} />
                      </Button>
                      {showHideSearch && (
                        <ul style={{ listStyleType: "none", width: "210px" }}>
                          <li>
                            <h6>
                              {" "}
                              <Search />
                              Zipcode
                            </h6>
                            <input
                              type="text"
                              minLength={0}
                              onChange={(e) => setZipCode(e.target.value)}
                              placeholder="Enter zip code"
                              value={zipCode}
                              autoComplete="off"
                            />
                          </li>

                          <li style={{ padding: "10px" }}>
                            <Button
                              variant="primary"
                              className="btn-blue btn-head"
                              onClick={() => {
                                setPageNumber(0);
                                setRerender(!rerender);
                              }}
                              style={{
                                backgroundColor: "black",
                                border: "none",
                                marginRight: "15px",
                              }}
                            >
                              Search
                            </Button>
                            <Button
                              variant="primary"
                              className="btn-blue btn-head"
                              onClick={() => {
                                setZipCode("");
                                setRerender(!rerender);
                              }}
                              style={{
                                backgroundColor: "black",
                                border: "none",
                              }}
                            >
                              Clear All
                            </Button>
                          </li>
                        </ul>
                      )}
                    </div>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          {showLoader ? (
            <div className="page-loader fixed">
              <div className="page-loader-inner">
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <section className="transaction-list shop-listing-wraper">
              {shops && shops.length >= 0 ? (
                <div className="container-custom">
                  <Row>
                    {/* studios rendered in list */}
                    {shops.map((shop) => {
                      return (
                        <Col xs="12" sm="3" key={shop._id}>
                          <Card className="transaction-single">
                            <Card.Body className="">
                              <div className="prod-img">
                                <img
                                  className="d-block w-100"
                                  src={
                                    shop &&
                                    shop.shopDetails &&
                                    shop.shopDetails.studioLogo
                                      ? UrlConstants.AdminCreateTransactionUrl +
                                        "/upload?id=" +
                                        shop._id +
                                        "&img=" +
                                        shop.shopDetails.studioLogo
                                      : placeholderImage
                                  }
                                  onClick={() => {
                                    let pathObj =
                                      shop &&
                                      shop.shopDetails &&
                                      shop.shopDetails.publicUrl &&
                                      shop.shopDetails.publicUrl !== undefined
                                        ? {
                                            pathname:
                                              "/studios/" +
                                              (shop &&
                                                shop.shopDetails &&
                                                shop.shopDetails.publicUrl),
                                          }
                                        : {
                                            pathname: "/studioDetails",
                                            state: {
                                              id: shop._id,
                                            },
                                          };
                                    history.push(pathObj);
                                  }}
                                />
                              </div>
                              <div
                                className="prod-text"
                                onClick={() => {
                                  let pathObj =
                                    shop &&
                                    shop.shopDetails &&
                                    shop.shopDetails.publicUrl &&
                                    shop.shopDetails.publicUrl !== undefined
                                      ? {
                                          pathname:
                                            "/studios/" +
                                            (shop &&
                                              shop.shopDetails &&
                                              shop.shopDetails.publicUrl),
                                        }
                                      : {
                                          pathname: "/studioDetails",
                                          state: {
                                            id: shop._id,
                                          },
                                        };
                                  history.push(pathObj);
                                }}
                              >
                                <Row>
                                  <Col>
                                    <Card.Title className="hedding-text">
                                      {shop &&
                                        shop.shopDetails &&
                                        shop.shopDetails.name}
                                    </Card.Title>

                                    <Card.Text className="small-text">
                                      Owner:{" "}
                                      {shop.firstname + " " + shop.lastname}
                                    </Card.Text>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col>
                                    <div className="small-text-para">
                                      <strong className="">Address:</strong>
                                      <span>
                                        {shop && shop.shopDetails
                                          ? shop.shopDetails.address +
                                            ", " +
                                            shop.shopDetails.city +
                                            ", " +
                                            shop.shopDetails.state +
                                            ", " +
                                            shop.shopDetails.zipcode
                                          : ""}
                                      </span>
                                    </div>

                                    <div className="small-text-para">
                                      <strong>Phone Number: </strong>
                                      <span className="">
                                        {shop && shop.shopDetails ? (
                                          <PhoneNumber
                                            phoneNumber={
                                              shop.shopDetails.phoneNumber
                                            }
                                          />
                                        ) : (
                                          ""
                                        )}
                                      </span>
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      );
                    })}
                  </Row>
                  {shops && shops.length > 0 && (
                    <div className="custom-pagination">
                      <ReactPaginate
                        previousLabel={"previous"}
                        nextLabel={"next"}
                        breakLabel={"..."}
                        pageCount={numberOfPages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={handlePageClick}
                        containerClassName={"pagination"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousClassName={"page-item"}
                        previousLinkClassName={"page-link"}
                        nextClassName={"page-item"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                        activeClassName={"active"}
                        forcePage={pageNumber}
                      />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="no-transaction no-record"
                  style={{ backgroundColor: "#379143" }}
                >
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p style={{ color: "black" }}>No studios found</p>
                  </div>
                </div>
              )}
            </section>
          )}
        </div>
      </div>
      {/* )} */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getAllShopsAction,
  }
)(ShopsListing);
